import FormattedMessage from 'I18n/components/FormattedMessage';
import * as links from '../../../lib/links';
import { InsertImageIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ViewToolbarAddLogo() {
  return /*#__PURE__*/_jsx(View, {
    borderRadius: "100",
    borderStyle: "dashed",
    borderWidth: "200",
    borderColor: "border-core-default",
    padding: "200",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexGrow: 0,
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(FoundationsView, {
        as: "span",
        marginInlineEnd: "200",
        children: /*#__PURE__*/_jsx(InsertImageIcon, {
          size: "600",
          color: "do-not-use-great-white"
        })
      }), /*#__PURE__*/_jsx(Link, {
        href: links.getBrandingURL(),
        external: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "view.toolbar.addLogo"
        })
      })]
    })
  });
}